import './task-list.scss';
import arrowUpIcon from '../../../../../assets//img/filter-arrows/003-arrow-up-gray.png';
import arrowDownIcon from '../../../../../assets//img/filter-arrows/004-arrow-down-gray.png';
import { useState } from 'react';
import userCirclePlusSolidIcon from '../../../../../assets/img/button-icons/user-circle-plus.svg';
import moment from 'moment';
import {
  isTodayDateString,
  isTodayOrBeforeTodayDateString,
  isBeforeTodayDateString,
} from '../../../../helpers';
import actionAlertIcon from '../../../../../assets/img/button-icons/action-alert.svg';
import { useSelector } from 'react-redux';
import HiddenTasks from './components/HiddenTasks';
import { EditPenOutline, TrashIcon } from '../../../Icons';
import { useLoggedInUser } from '../../../../../context';

export const TaskItem = ({
  task,
  editButton,
  deleteButton,
  onCompletedTask,
  onUncompleteTask,
  canAssignTask,
}) => {
  const {
    description: taskName,
    ended_at,
    due_date,
    assignedPersonInfo,
    assignedTeamInfo,
    details,
    id,
  } = task;
  const [isCompleted, setIsCompleted] = useState(() => !!ended_at);

  const handleCheckboxChange = () => {
    if (isCompleted && onUncompleteTask) {
      onUncompleteTask(id);
      setIsCompleted(false);
    } else if (!isCompleted && onCompletedTask) {
      onCompletedTask(id);
      setIsCompleted(true);
    }
  };

  return (
    <div className="task-item-container">
      <div className="task-info-container">
        {canAssignTask ? (
          <div>
            <input
              className="checkbox-round"
              type="checkbox"
              checked={isCompleted}
              onChange={handleCheckboxChange}
            />
          </div>
        ) : (
          <div style={{ padding: '5px' }}></div>
        )}
        <div className="task-info">
          <div>{taskName}</div>

          <div className="task-description">{details?.description ?? ''}</div>
        </div>
      </div>
      <div className="text-right task-actions-container">
        {canAssignTask ? (
          <div>
            {editButton}
            {deleteButton}
          </div>
        ) : (
          <div></div>
        )}
        <div className="assign-info">
          {assignedPersonInfo ? (
            <div>
              <img
                src={userCirclePlusSolidIcon}
                alt="Clinician name"
                className="icon"
                style={{ marginRight: '4px', marginBottom: '5px' }}
              />
              {assignedPersonInfo.first_name} {assignedPersonInfo.last_name}
            </div>
          ) : null}
          {assignedTeamInfo ? (
            <div>Team: {assignedTeamInfo.clinic_name}</div>
          ) : null}
          {due_date ? (
            <div
              className={`task-due-info ${isTodayOrBeforeTodayDateString(due_date) ? 'task-due-active' : ''}`}
            >
              {isTodayOrBeforeTodayDateString(due_date) ? (
                <span className="icon-container">
                  <img src={actionAlertIcon} alt="due today alert" />{' '}
                </span>
              ) : null}
              {isBeforeTodayDateString(due_date) ? 'Overdue' : 'Due'}{' '}
              {isTodayDateString(due_date)
                ? 'today'
                : moment(due_date).format('DD MMM YYYY')}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const TaskList = ({
  tasks,
  onEditTask,
  onCompletedTask,
  onUncompleteTask,
  onDeleteTask,
  canAssignTask,
}) => {
  const { loggedInUser } = useLoggedInUser();
  const [showCompletedTask, setShowCompletedTask] = useState(false);
  const { hiddenTasks } = useSelector((state) => state.preferences);
  const completedTasks = tasks.filter((task) => !!task.ended_at);
  const openTasks = tasks.filter(
    (task) =>
      (!task.ended_at && !hiddenTasks.includes(task.description)) ||
      (!task.ended_at && loggedInUser.userId === task.clinician_id),
  );

  const hiddenTaskList = tasks.filter(
    (task) =>
      !task.ended_at &&
      hiddenTasks.includes(task.description) &&
      loggedInUser.userId !== task.clinician_id,
  );

  return (
    <div className="task-items-container">
      <ul>
        {openTasks.map((task) => {
          return (
            <li key={task.id}>
              <TaskItem
                task={task}
                onCompletedTask={onCompletedTask}
                editButton={
                  <button type="button" onClick={() => onEditTask(task)}>
                    <EditPenOutline />
                  </button>
                }
                deleteButton={
                  <button type="button" onClick={() => onDeleteTask(task.id)}>
                    <TrashIcon />
                  </button>
                }
                canAssignTask={canAssignTask}
              />
            </li>
          );
        })}
      </ul>
      <HiddenTasks
        upIcon={<img src={arrowUpIcon} alt="arrow up icon" />}
        downIcon={<img src={arrowDownIcon} alt="arrow down icon" />}
        hiddenTasks={hiddenTaskList}
        onEditTask={onEditTask}
        canAssignTask={canAssignTask}
        onCompletedTask={onCompletedTask}
        onUncompleteTask={onUncompleteTask}
        onDeleteTask={onDeleteTask}
      />
      <div className="divider-white" />
      <div className="completed-tasks-header">
        <button
          type="button"
          onClick={() => setShowCompletedTask((show) => !show)}
        >
          Completed tasks
          <span style={{ marginLeft: '4px' }}>
            {showCompletedTask ? (
              <img src={arrowDownIcon} alt="arrow down icon" />
            ) : (
              <img src={arrowUpIcon} alt="arrow up icon" />
            )}
          </span>
        </button>
      </div>
      {showCompletedTask ? (
        <ul>
          {completedTasks.map((task) => {
            return (
              <li key={task.id}>
                <TaskItem
                  task={task}
                  onUncompleteTask={onUncompleteTask}
                  editButton={null}
                  deleteButton={
                    <button type="button" onClick={() => onDeleteTask(task.id)}>
                      <TrashIcon />
                    </button>
                  }
                  canAssignTask={canAssignTask}
                />
              </li>
            );
          })}
        </ul>
      ) : null}
      <div className="divider" />
    </div>
  );
};
